export const ENGLISH_LANGUAGE = createLanguage('en', 'English');
export const LANGUAGES = Object.freeze([
    createLanguage('cs', 'Čeština'),
    createLanguage('de', 'Deutsch'),
    ENGLISH_LANGUAGE,
    createLanguage('en-AU', 'English (AU)'),
    createLanguage('en-GB', 'English (UK)'),
    createLanguage('en-US', 'English (US)'),
    createLanguage('es', 'Español'),
    createLanguage('fr', 'Français'),
    createLanguage('it', 'Italiano'),
    createLanguage('hu', 'Magyar'),
    createLanguage('nl', 'Nederlands'),
    createLanguage('nb', 'Norsk (bokmål)'),
    createLanguage('pl', 'Polski'),
    createLanguage('pt-BR', 'Português (Brasil)'),
    createLanguage('fi', 'Suomi'),
    createLanguage('sv', 'Svenska'),
    createLanguage('vi', 'Tiếng Việt'),
    createLanguage('tr', 'Türkçe'),
    createLanguage('ru', 'Русский'),
    createLanguage('uk', 'Українська'),
    createLanguage('th', 'ภาษาไทย'),
    createLanguage('zh-Hans', '中文 (简体)'),
    createLanguage('zh-Hant', '中文 (繁體)'),
    createLanguage('ja', '日本語')
]);
export const LANGUAGE_CODES = Object.freeze(LANGUAGES.map(({ code }) => code));
export const NON_ENGLISH_LANGUAGE_CODES = LANGUAGE_CODES.filter((languageCode) => !isEnglishLanguageCode(languageCode));
export const DEFAULT_LANGUAGE_CODE = ENGLISH_LANGUAGE.code;
export function createLanguage(code, name) {
    return Object.freeze({ code, name });
}
export function isLanguageCode(value) {
    return LANGUAGE_CODES.some((languageCode) => value === languageCode);
}
export function isEnglishLanguageCode(languageCode) {
    switch (languageCode) {
        case 'en':
        case 'en-AU':
        case 'en-US':
        case 'en-GB':
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=languages.js.map